module.exports = __webpack_public_path__ + "d220cd55611078335ff011aa91fba98f.svg";